var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAdminsIcon = function SvgAdminsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#D8D8D8",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.995 9.5.646.403c1.738 1.047 3.713 1.727 5.93 2.04l.429.06-.003 1.225-.01.735-.015.681-.024.633-.033.59-.04.552-.025.264-.056.508a17.3 17.3 0 0 1-.067.484l-.079.467c-.042.23-.089.455-.14.679l-.11.447-.125.449-.138.456c-.911 2.88-2.795 4.93-5.631 6.125l-.5.202-.186-.072c-3.012-1.17-5.007-3.265-5.953-6.255l-.138-.456-.124-.45-.11-.446c-.052-.224-.099-.45-.141-.68l-.079-.466a17.82 17.82 0 0 1-.096-.735l-.051-.52-.041-.554-.033-.59-.024-.632-.016-.68-.01-.736L11 12.004l.43-.06c2.374-.336 4.472-1.093 6.297-2.271l.268-.173ZM18 13.093l-1.502 2.569-2.998.583 2.07 2.17-.351 2.928L18 20.117l2.781 1.226-.351-2.928 2.07-2.17-2.998-.583L18 13.093Z",
    fill: "#000"
  }))));
};
export default SvgAdminsIcon;